export const mergeUnavailableItems = (cartItems, unavailableItems) =>
  cartItems.reduce((acc, item) => {
    const unavailableItem = unavailableItems[item.id];
    if (unavailableItem) return [...acc, { ...item, ...unavailableItem }];
    return acc;
  }, []);

export const mergeUnavailableMedleyItems = ({
  cartMedleySets = [],
  unavailableMedleyItems = {},
  unavailableLineItems = {},
}) =>
  cartMedleySets.reduce((acc, item) => {
    const medleySet = unavailableMedleyItems[item.id];
    if (medleySet) return [...acc, { ...item, ...medleySet, productId: item.medleyId }];

    const unavailableMedleyComponents = item.medleyComponents.reduce((acc, component) => {
      const unavailableComponent = unavailableLineItems[component.id];
      if (unavailableComponent)
        return [
          ...acc,
          {
            ...component,
            ...unavailableComponent,
            availableQuantity: Math.floor(unavailableComponent.availableQuantity / item.quantity),
          },
        ];
      return acc;
    }, []);

    if (unavailableMedleyComponents.length)
      return [
        ...acc,
        { ...item, medleyComponents: unavailableMedleyComponents, productId: item.medleyId },
      ];
    else return acc;
  }, []);

export const findItemIndex = (items, productId, storeId = null) =>
  items.findIndex(
    ({ productId: id, storeId: strId = null }) => productId === id && +storeId === +strId,
  );

export const findMedleyItemIndex = (items, itemId) => items.findIndex(({ id }) => itemId === id);

export const findUnavailableItems = (availableItems, unavailableItems) =>
  unavailableItems.filter(
    ({ productId, storeId }) => findItemIndex(availableItems, productId, storeId) === -1,
  );

export const mapRemovedItemsWithZeroQuantity = (removedItems) =>
  removedItems.map((item) => ({ ...item, quantity: 0 }));

export const updateMedleyComponents = (medleySetsWithDetails, unavailableMedleyItems) => {
  const removedMedleySets = [];
  unavailableMedleyItems.forEach((item) => {
    const { productId } = item;
    const medley = medleySetsWithDetails.find(({ productId: id }) => productId === id);
    if (medley) {
      const removedMedleyComponents = findUnavailableItems(
        medley.medleyComponents,
        item.medleyComponents,
      );
      medley.medleyComponents = [
        ...medley.medleyComponents,
        ...mapRemovedItemsWithZeroQuantity(removedMedleyComponents),
      ];
    } else {
      removedMedleySets.push({ ...item, quantity: 0 });
    }
  });
  return removedMedleySets;
};
